import { getOrgIdFromHostname, getOrgSlugFromHostname } from '@/core/domain';
import jsonpack from 'jsonpack';
import type { TypedDocumentString } from './graphql';

export const getAuthToken = () => {
  // const jwt = getToken();
  // if (jwt) return `Bearer ${jwt}`;

  const token = new URLSearchParams(window.location.search).get('token');
  if (token) {
    const linkPassword = sessionStorage.getItem('link-password');
    if (linkPassword) return `Token ${token}:${btoa(linkPassword)}`;
    return `Token ${token}`;
  }

  return '';
};

const getLinkSessionId = (): string | null => {
  const token = new URLSearchParams(window.location.search).get('token');
  if (!token) return null;

  const key = 'link-session-id';
  let sessionId = sessionStorage.getItem(key);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(key, sessionId);
  }
  return sessionId;
};

export async function execute<TResult, TVariables>(
  query: TypedDocumentString<TResult, TVariables>,
  ...[variables]: TVariables extends Record<string, never> ? [] : [TVariables]
) {
  const url = new URL(import.meta.env.VITE_ENDPOINT);
  url.pathname = '/gql';

  const orgId = getOrgIdFromHostname();
  const slug = getOrgSlugFromHostname();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/graphql-response+json',
    Authorization: getAuthToken(),
  };

  const linkSessionId = getLinkSessionId();
  if (linkSessionId) headers['X-Link-Session'] = linkSessionId;

  if (orgId) headers['x-organisation'] = orgId;
  else if (slug) headers['X-Organization-Slug'] = slug;

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  if (!response.ok) throw new Error('Network response was not ok');

  const body = await response.text();
  let res;
  try {
    res = JSON.parse(body);

    if (res.data) return res.data as TResult;
  } catch {}

  if (res?.errors) throw new Error(res.errors[0].message);

  try {
    res = jsonpack.unpack(body) as any;

    return res.data as TResult;
  } catch (error) {
    throw error;
  }
}
